import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pinLat: '',
    pinLng: '',
    pinAddress: ''
};

export const addProjectCenterPinSlice = createSlice({
    name: "addProjectCenterPin",
    initialState,
    reducers: {
        updateProjectCenterPin: (state, action) => {
            state.pinLat = action.payload.pinLat;
            state.pinLng = action.payload.pinLng;
            state.pinAddress = action.payload.pinAddress;
        }
    },
});

export const { updateProjectCenterPin } = addProjectCenterPinSlice.actions;
export default addProjectCenterPinSlice.reducer;